import script from "./BackupsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackupsTable.vue?vue&type=script&setup=true&lang=ts"

import "./BackupsTable.vue?vue&type=style&index=0&id=6094201b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6094201b"]])

export default __exports__